// ── Flash of wrong content fix ──────────────────────────────────────────────
// Hides the page immediately on collection pages, revealed once Algolia renders
(function () {
  if (!document.body.classList.contains('page-collection')) return;
  const style = document.createElement('style');
  style.id = 'at-fouc-fix';
  style.textContent = '.page-collection main { visibility: hidden !important; }';
  document.head.appendChild(style);
  // Safety net: reveal page even if Algolia renders no products
  setTimeout(() => {
    const s = document.getElementById('at-fouc-fix');
    if (s) s.remove();
  }, 2500);
})();
// ────────────────────────────────────────────────────────────────────────────


document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchFiltersString",
    function (defaultFilter) {
      if (defaultFilter && defaultFilter.includes("collection_ids")) {
        const collectionIDFilterRegex = /collection_ids:"\w+"/g;
        const matches = window.location.pathname.match(
          /\/collections\/([^/]+)/i,
        );
        const collectionHandle =
          matches && matches.length === 2 ? matches[1] : null;

        if (collectionHandle) {
          return defaultFilter.replace(
            collectionIDFilterRegex,
            "collections:" + collectionHandle,
          );
        }
      }

      return defaultFilter;
    },
  );
});

// Add the compare at price in the search header
document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {

      const { html, item, components } = templateOptions;
      return html`
    <a
      href="${itemLink}"
      class="aa-ItemLink aa-ProductItem"
      onClick="${() => trackSearchAttribution(item)}"
    >
      <div class="aa-ItemContent">
        <div class="aa-ItemPicture aa-ItemPicture--loaded">
          <img
            src="${algoliaShopify.helpers.renderImage(item, 125).src}"
            srcset="${algoliaShopify.helpers.renderImage(item, 125).srcset}"
            sizes="${algoliaShopify.helpers.renderImage(item, 125).sizes}"
            alt="${item.title}"
          />
        </div>
        <div class="aa-ItemContentBody">
          <div class="aa-ItemContentBrand">
            ${
              item.product_type &&
              components.Highlight({ hit: item, attribute: "product_type" })
            }
            ${item.vendor &&
              html`
                <span> by </span>
              `
            }
            ${item.vendor &&
              components.Highlight({ hit: item, attribute: 'vendor' })
            }
          </div>
          <div class="aa-ItemContentTitleWrapper">
            <div class="aa-ItemContentTitle">
              ${components.Highlight({ hit: item, attribute: "title" })}
              <span class="algolia-variant">
                ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
              </span>
            </div>
          </div>
          <div class="aa-ItemContentPrice">
            <div class="aa-ItemContentPriceCurrent">
              ${algoliaShopify.helpers.displayPrice(item, distinct)}
              ${!item._distinct &&
              html`
                <span class="aa-ItemPriceStriked" style="margin-left: 4px; color: red; text-decoration: line-through; font-weight:500;"
                  ><span
                    >${algoliaShopify.helpers.displayStrikedPrice(
                      item.price,
                      item.compare_at_price
                    )}</span
                  ></span
                >
              `}
            </div>
          </div>
        </div>
      </div>
    </a>
  `;
    }
  );
});


// Reveal page as soon as InstantSearch initializes (covers empty collections)
document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook("beforeInstantSearchOptions", function (options) {
    const foucStyle = document.getElementById('at-fouc-fix');
    if (foucStyle) foucStyle.remove();
    return options;
  });
});


document.addEventListener("algolia.hooks.initialize", function () {
algoliaShopify.hooks.registerHook(
  "beforeInstantSearchProductTemplate",
  function (_defaultTemplate, hit, html, components, trackSearchAttribution) {

    // ── Remove FOUC fix on first Algolia render ──────────────────────────────
    const foucStyle = document.getElementById('at-fouc-fix');
    if (foucStyle) foucStyle.remove();
    // ────────────────────────────────────────────────────────────────────────

    const handle = hit.handle || "";
    const id = hit.objectID || Math.random().toString(36).substring(7);
    const tags = Array.isArray(hit.tags) ? hit.tags : [];
    const vendor = (hit.vendor || "").toLowerCase();

    const hasTVsTag = tags.includes("TVs");
    const hasACTag = tags.includes("Air Conditioners");
    const hasAppleLaptopTag = tags.includes("Laptops") && vendor === "apple";

    const showCompare = hasTVsTag || hasACTag || hasAppleLaptopTag;

    // ── Discount badge ──────────────────────────────────────────
    const price = hit.price;
    const compare = hit.compare_at_price;
    const showDiscount = compare && compare > price;
    const discountPct = showDiscount ? Math.round((1 - price / compare) * 100) : 0;
    // ────────────────────────────────────────────────────────────

    if (showCompare && !document.getElementById("sc-tvs-compare-style")) {
      const style = document.createElement("style");
      style.id = "sc-tvs-compare-style";
      style.textContent = `
        .page-collection .algolia-hit-wrapper {
          min-height: 475px !important;
        }
      `;
      document.head.appendChild(style);
    }

    setTimeout(() => {
      if (window.SCCompare && typeof window.SCCompare.init === "function") {
        window.SCCompare.init();
      }
      const elList = document.querySelectorAll("sc-add-to-compare");
      elList.forEach(el => {
        if (window.customElements && customElements.upgrade) {
          customElements.upgrade(el);
        }
      });
    }, 0);

return html`
  <div class="algolia-hit-wrapper">

    ${showDiscount ? html`
      <span class="discount-badge">-${discountPct}%</span>
    ` : ''}

    ${_defaultTemplate}

    ${showCompare ? html`
      <div class="algolia-compare-btn">
        <sc-add-to-compare product-handle="${handle}">
          <input 
            id="${id}-add-to-compare" 
            type="checkbox" 
            style="display:none"
          />
          <label 
            for="${id}-add-to-compare" 
            class="button"
          >
            Add to compare
          </label>
        </sc-add-to-compare>
      </div>
    ` : ''}

  </div>
`;
  }
);
});



// Query Suggestions

document.addEventListener('algolia.hooks.initialize', function() {
    algoliaShopify.hooks.registerHook("beforeAutocompleteOptions", function(options) {

        const { searchClient } = window.algoliaShopify;
        const { getAlgoliaResults } = window.algoliaShopify.externals;

        const customSuggestionsPlugin = {
            name: "custom-custom-suggestion-plugin",
            getSources({ query }) {
                let staticHits = [];

                return [{
                    sourceId: "customSuggestions",
                    getItems() {
                        return getAlgoliaResults({
                            searchClient,
                            queries: [{
                                indexName: "shopify_products_query_suggestions",
                                query,
                            }],
                            transformResponse({ hits, results }) {
                                const [qsHits = []] = hits;

                                // Extract static hits from userData
                                try {
                                    staticHits = results[0].userData[0].staticQuerySuggestions || staticHits;
                                } catch (e) {}

                                const seen = new Set();

                                // Merge static hits and API hits, dedupe by objectID
                                const mergedHits = [...staticHits, ...qsHits].filter((item) => {
                                    const id = item && item.objectID;
                                    if (!id) return false;
                                    if (seen.has(id)) return false;
                                    seen.add(id);
                                    return true;
                                });

                                // Return only first 5 suggestions
                                return mergedHits.slice(0, 5);
                            },
                        });
                    },

                    templates: {
                        header({ html }) {
                            return html`
                                <div class="aa-SourceHeader">
                                    <span class="aa-SourceHeaderTitle">Suggested Key Words</span>
                                    <div class="aa-SourceHeaderLine"></div>
                                </div>
                            `;
                        },

                        item({ item, html }) {
                            // Nice clickable link to search
                            return html`
                                <div class="aa-ItemContent">
                                    <a href="/search?q=${encodeURIComponent(item.objectID)}">
                                        ${item.objectID}
                                    </a>
                                </div>
                            `;
                        },
                    },
                }];
            },
        };

        options.plugins.push(customSuggestionsPlugin);
        return options;
    });

    algoliaShopify.hooks.registerHook("beforeAutocompleteMainTemplate", function(_defaultTemplate, templateOptions, elements, displaySuggestions) {
        const { html, state } = templateOptions;
        const query = (state?.query ?? "").trim();

        return html`
            <div class="aa-PanelLayout aa-Panel--scrollable">
                <div class="aa-PanelSections">
                    <div class="aa-PanelSection--left">
                    <div class="sugg-mobile"> ${elements.customSuggestions}</div>
                        ${displaySuggestions &&
                            html`
                                <div class="aa-SourceHeader">
                                    <span class="aa-SourceHeaderTitle">
                                        ${window.algoliaShopify.translations.suggestions}
                                    </span>
                                    <div class="aa-SourceHeaderLine"></div>
                                </div>
                                ${elements.querySuggestionsPlugin}
                            `}
                        ${elements.products}
                    </div>
                    <div class="aa-PanelSection--right">
                         
                        ${elements.articles} 
                        ${elements.pages}
                        ${elements.redirectUrlPlugin}
                        <div class="sugg-desktop"> ${elements.customSuggestions}</div>
                        ${elements.saleItems}


                        <section class="aa-Source" data-autocomplete-source-id="brands">

                        <div class="aa-SourceHeader"><div class="aa-SourceHeader"><span class="aa-SourceHeaderTitle">Suggested Brands</span><div class="aa-SourceHeaderLine"></div></div></div>


                          <div class="at-search-brands">

                            <div class="at-search-brand">
                              <a href="https://abedtahan.com/pages/apple">
                                <img src="//im8a30fz7dkvzxqa-60565684403.shopifypreview.com/cdn/shop/files/apple_b3e4740b-e2f6-4055-882f-bb6395e71246.png?v=1757420120"></img>
                              </a>
                            </div>

                            <div class="at-search-brand">
                              <a href="https://abedtahan.com/collections/samsung">
                                <img src="//im8a30fz7dkvzxqa-60565684403.shopifypreview.com/cdn/shop/files/samsung_503f95eb-6895-49e9-87d0-04dd39f9a939.png?v=1757420272"></img>
                              </a>
                            </div>

                            <div class="at-search-brand">
                              <a href="https://abedtahan.com/collections/sony">
                                <img src="//im8a30fz7dkvzxqa-60565684403.shopifypreview.com/cdn/shop/files/sony_0ef547d8-ccff-4a2d-acff-6cfa6b4c492f.png?v=1757420207"></img>
                              </a>
                            </div>

                            <div class="at-search-brand">
                              <a href="https://abedtahan.com/pages/tcl">
                                <img src="//im8a30fz7dkvzxqa-60565684403.shopifypreview.com/cdn/shop/files/TCL_f985a6fc-e04b-4d27-ac86-087eb05f7cc0.png?v=1757420119"></img>
                              </a>
                            </div>



                            <div class="at-search-brand">
                                <a href="https://abedtahan.com/pages/dyson-brand">
                                <img src="https://abedtahan.com/cdn/shop/files/dyson_eb8ae2a2-0f63-4a28-b27a-dd608d10dd57.png?v=1757420120"></img>
                                </a>
                            </div>

                            <div class="at-search-brand">
                                <a href="https://abedtahan.com/pages/ninja">
                                <img src="https://abedtahan.com/cdn/shop/files/ninja.png?v=1757420120"></img>
                                </a>
                            </div>

                          </div>
                        </section>


                        ${elements.collections}
                    </div>
                </div>
            </div>
        `;
    });
});


// Prevent unnecessary Algolia API calls

const MIN_CHARS = 3;
const DEBOUNCE_DELAY = 0;

function hasEnoughChars(value) {
  const v = value.trim().toUpperCase();
  if (v === 'AC' || v === 'TV') return true;
  return v.length >= MIN_CHARS;
}

document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteOptions",
    function (options) {
      const debounce = (fn, delay) => {
        let timer;
        let lastCallId = 0;
        return (...args) => {
          const callId = ++lastCallId;
          return new Promise((resolve) => {
            clearTimeout(timer);
            timer = setTimeout(async () => {
              const result = await fn(...args);
              if (callId === lastCallId) {
                resolve(result);
              }
            }, delay);
          });
        };
      };

      options.plugins
        .filter(p => typeof p.getSources === "function")
        .forEach(plugin => {
          const originalGetSources = plugin.getSources;
          const debounced = debounce(originalGetSources, DEBOUNCE_DELAY);
          plugin.getSources = (params) => {
            const query = (params?.query ?? "").trim();
            if (!hasEnoughChars(query)) {
              // This is what truly stops API calls
              return Promise.resolve([]);
            }
            return debounced(params);
          };
        });
      return options;
    }
  );
});


// Lock on Open
// function panelScrollLock() {
//   const defPanel = document.querySelector('.def-Panel');
//   const aaPanel = document.querySelector('.aa-Panel');

//   const shouldLock = 
//     (defPanel && window.getComputedStyle(defPanel).display !== 'none') ||
//     (aaPanel && window.getComputedStyle(aaPanel).display !== 'none');


//   document.body.style.overflow = shouldLock ? 'hidden' : '';
// }




// Keystrokes Desktop

if (window.innerWidth >= 981) {
  (function () {
    function init() {
      const input = document.querySelector('.aa-Input');

      if (!input) {
        setTimeout(init, 300);
        return;
      }

      function hasEnoughChars(value) {
        const v = value.trim().toUpperCase();
        if (v === 'AC' || v === 'TV') return true;
        return v.length >= 3;
      }

      function togglePanel() {
        const panel = document.querySelector('.aa-Panel');
        const panell = document.querySelector('.aa-NoResultsHeader');
        const panelll = document.querySelector('.aa-NoResultsLink');
        const defpanel = document.querySelector('.def-Panel');
        if (!panel || !defpanel) return;
        if (!hasEnoughChars(input.value)) {
       
          panell.style.display = 'none';
          panelll.style.display = 'none';
          defpanel.style.display = 'block';
        } else {
 
          panell.style.display = '';
          panelll.style.display = '';
          defpanel.style.display = 'none';
        }
      }

      input.addEventListener('focus', () => {
         document.body.classList.add('focused');
        const defpanel = document.querySelector('.def-Panel');
        if (!defpanel) return;
        if (!hasEnoughChars(input.value)) {
          defpanel.style.display = 'block';
        }
      });

      input.addEventListener('blur', () => {
        setTimeout(() => {
          document.body.classList.remove('focused');
          const defpanel = document.querySelector('.def-Panel');
          if (defpanel) {
            defpanel.style.display = 'none';
          }
        }, 500); 
      });

      input.addEventListener('input', togglePanel);
      const observer = new MutationObserver(togglePanel);
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    init();
  })();
}



// Keystrokes Mobile

if (window.innerWidth < 981) {
  (function () {
    function init() {
      const input = document.querySelector('.aa-Input');

      if (!input) {
        setTimeout(init, 300);
        return;
      }

      function hasEnoughChars(value) {
        const v = value.trim().toUpperCase();
        if (v === 'AC' || v === 'TV') return true;
        return v.length >= 3;
      }

      const defpanelInit = document.querySelector('.aa-Detached .def-Panel');
      if (defpanelInit) {
        defpanelInit.style.display = 'block';

      }

      function togglePanel() {
        const panel = document.querySelector('.aa-Panel');
        const panell = document.querySelector('.aa-NoResultsHeader');
        const panelll = document.querySelector('.aa-NoResultsLink');
        const defpanel = document.querySelector('.aa-Detached .def-Panel');
        if (!panel || !defpanel) return;

        if (!hasEnoughChars(input.value)) {

          panell.style.display = 'none';
          panelll.style.display = 'none';
          defpanel.style.display = 'block';

        } else {

          panell.style.display = '';
          panelll.style.display = '';
          defpanel.style.display = 'none';

        }
      }


      input.addEventListener('input', togglePanel);
      const observer = new MutationObserver(togglePanel);
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    init();
  })();
}